import { render, staticRenderFns } from "./ServicoListFiltroModalItemServicos.vue?vue&type=template&id=ac0a7314"
import script from "./ServicoListFiltroModalItemServicos.vue?vue&type=script&lang=js"
export * from "./ServicoListFiltroModalItemServicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports